import { ChatModel } from './../../models/chat.model';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { finalize } from 'rxjs/operators';
import { ProductModel } from './../../models/wardrobe.model';
import { OfferService } from 'src/app/services/offer.service';
import { OfferDetailModel } from 'src/app/models/wardrobe.model';
import { GeneralService } from './../../services/general.service';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { WardrobeService } from 'src/app/services/wardrobe.service';
import { PaginatedResponse } from './../../models/paginated-response.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { CounterOfferModalComponent } from '../counter-offer-modal/counter-offer-modal.component';
import { STATUS_ACCEPTED, STATUS_PROCESSING, STATUS_REJECTED, OFFER_TYPE_SWAP_REQUEST } from 'src/app/constants/general.constant';
import { UserModel } from 'src/app/models/user.model';

@Component({
  selector: 'shc-offer-notifications-modal',
  templateUrl: './offer-notifications-modal.component.html',
  styleUrls: ['./offer-notifications-modal.component.scss'],
})
export class OfferNotificationsModalComponent implements OnInit {
  page: number;
  userDetail: UserModel;
  STATUS_REJECTED: string;
  STATUS_ACCEPTED: string;
  STATUS_PROCESSING: string;

  @Input() product: ProductModel;
  offers: PaginatedResponse<OfferDetailModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  constructor(
    private wardrobeService: WardrobeService,
    private generalService: GeneralService,
    private modalCtrl: ModalController,
    private offerService: OfferService,
    private errorService: ErrorHandlerService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
    this.page = 1;
    this.STATUS_ACCEPTED = STATUS_ACCEPTED;
    this.STATUS_REJECTED = STATUS_REJECTED;
    this.STATUS_PROCESSING = STATUS_PROCESSING;
    console.log(this.product);
    this.userService.get().subscribe(res => {
      this.userDetail = res;
    });
    this.getOffersList('');
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  getOffersList(event) {
    this.generalService.showLoader();
    this.wardrobeService.offerList({ page: this.page, product_id: this.product.id }).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      console.log(res);
      if (this.offers && this.offers.meta) {
        if (this.page === 1) {
          this.offers = res;
        } else {
          this.offers.meta = res.meta;
          this.offers.data = [...this.offers.data, ...res.data];
        }
      } else {
        this.offers = res;
      }
      if (event) {
        event.target.complete();
      }
      this.page++;
    });
  }

  refreshOfferList(event){
    this.offers.data = [];
    this.page = 1;
    this.getOffersList(event);
  }

  async counterOffer() {
    const modal = await this.modalCtrl.create({
      component: CounterOfferModalComponent,
      cssClass: 'counterOfferModal',
      canDismiss: true,
      backdropDismiss: true,
      id: 'counterOffer',
      mode: 'md'
    });
    modal.onDidDismiss().then((data) => {
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  acceptOffer(id): void {
    this.offerService.updateOffer(id, STATUS_ACCEPTED).subscribe(res => {
      // this.offerItem = res;
      console.log("acceptOffer res",res);
      
      const index = this.offers.data.findIndex(off => off.id === id);
      this.offers.data[index].status = res.status;
      if(this.offers.data[index].offer_type !== OFFER_TYPE_SWAP_REQUEST){
        this.refreshOfferList('');
      }
    }, error => {
      this.errorService.handle(error);
    });
  }

  declineOffer(id): void {
    this.offerService.updateOffer(id, STATUS_REJECTED).subscribe(res => {
      // this.offerItem = res;
      const index = this.offers.data.findIndex(off => off.id === id);
      if(this.offers.data[index].offer_type === OFFER_TYPE_SWAP_REQUEST){
        this.refreshOfferList('');
      }
    }, error => {
      this.errorService.handle(error);
    });
  }

  loadData(event): void {
    if (this.offers.meta.current_page < this.offers.meta.last_page) {
      this.getOffersList(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }

  gotoOfferChat(chat: ChatModel) {
    if(! chat?.id) {
      return;
    }
    this.router.navigate(['/chat/'+chat?.id]);
    this.modalCtrl.dismiss();
  }
  

}
